import React from 'react';
import displayName from 'component-lib/displayName';
import Icon from './Icon';

export default function DialogAlertIcon() {
    return <Icon type="alert" />;
}

DialogAlertIcon.displayName = displayName('Dialog/AlertIcon');
